import { NamedOffenderTypeForDisplay } from 'src/types';
import {
  FormattedNamedOffender,
  NamedOffenderForDisplay,
} from './formattedNamedOffender.type';

export const formatReportNamedOffendersForDisplay = (
  namedOffenders: FormattedNamedOffender[],
): NamedOffenderForDisplay[] => {
  const formattedNamedOffenders = namedOffenders.flatMap((offender) =>
    offender.reports.map((report) => ({
      id: offender.id,
      name: offender.name,
      reportOrEvent: `Report ID: ${report.id}`,
      badgeText:
        report.type === 'Presubmission'
          ? NamedOffenderTypeForDisplay.TIME_OF_SUBMISSION
          : NamedOffenderTypeForDisplay.POST_SUBMISSION,
    })),
  );

  return formattedNamedOffenders;
};

export const formatEventNamedOffendersForDisplay = (
  namedOffenders: FormattedNamedOffender[],
): NamedOffenderForDisplay[] => {
  const formattedNamedOffenders = namedOffenders.flatMap((offender) =>
    offender.events.map((event) => ({
      id: offender.id,
      name: offender.name,
      reportOrEvent: `Event ID: ${event.id}`,
      badgeText:
        event.type === 'Presubmission'
          ? NamedOffenderTypeForDisplay.TIME_OF_SUBMISSION
          : NamedOffenderTypeForDisplay.POST_SUBMISSION,
    })),
  );

  return formattedNamedOffenders;
};
